import { render, staticRenderFns } from "./Servers.vue?vue&type=template&id=94adcb42&scoped=true&"
import script from "./Servers.vue?vue&type=script&lang=js&"
export * from "./Servers.vue?vue&type=script&lang=js&"
import style0 from "./Servers.vue?vue&type=style&index=0&id=94adcb42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94adcb42",
  null
  
)

component.options.__file = "Servers.vue"
export default component.exports